import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserFilter } from '../enums/user-filter';
import { UserRelation } from '../enums/user-relation';
import { User } from '../interfaces/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  userDataSubject = new Subject();
  userSave = new Subject();

  constructor(private http: HttpClient) { }

  /**
   * Get all user which belong to a company
   *
   * @param companyId The ID of the company
   * @param relation Get the user tables only with the IDs (default) or also the related table informations
   * @param filters Filter for the request
   * @returns All users which belong to the company
   */
  getUsersByCompanyId(companyId: string, relation = UserRelation.NONE, filters: UserFilter[] = []) {

    let filterString = `"company._id":"${companyId}"`;

    for (const userFilter of filters) {
      filterString = filterString.concat(', ' + userFilter);
    }

    return this.http.get<User[]>(
      `${environment.url}/bucket/${environment.buckets.users}/data?relation=${relation}&filter={${filterString}}`
    );
  }

  /**
   * Get a user from his ID
   *
   * @param id The ID of the user
   * @param relation Get the user tables only with the IDs (default) or also the related table informations
   * @returns The user which belong to the ID
   */
  getUserById(id: string, relation = UserRelation.NONE) {
    return this.http.get<User>(`${environment.url}/bucket/${environment.buckets.users}/data/${id}?relation=${relation}`);
  }

  saveUser(user): Observable<any> {
    if (user._id) {
      const flated = this.flatUser(user);
      return this.updateUser(flated);
    } else {
      return this.addUser(user);
    }

  }

  private updateUser(data: any) {
    return this.http.put<User>(
      // eslint-disable-next-line no-underscore-dangle
      `${environment.url}/bucket/${environment.buckets.users}/data/${data._id}`,
      data
    );
  }

  private addUser(data: User) {
    return this.http.post<User>(
      `${environment.url}/bucket/${environment.buckets.users}/data`,
      data
    );
  }

  // TODO: muss noch eroiert werden
  // erste überlegung: User wird inaktiv geschalten?!
  deleteUser(id: string) {
    return this.http.delete(`${environment.url}/fn-execute/disableUser?user=${id}`);
  }

  deleteUser2(user) {
    return this.http.delete(`${environment.url}/bucket/${environment.buckets.users}/data/${user._id}`)
  }
  flatUser(user) {
    if (user.company) {
      if (typeof user.company !== "string")
        user.company = user.company._id;
    }
    if (user.ressource) {
      if (typeof user.ressource !== "string")
        user.ressource = user.ressource._id;
    }
    return user;
  }

  setPassword(user_id: string, password: string) {
    return this.http.post(`${environment.url}/fn-execute/setpassword`, {
      user: user_id,
      password
    });
  }
}
